enum MemberEducation {
  NoFormalEducation = 'NO_FORMAL_EDUCATION',
  PrimarySchool = 'PRIMARY_SCHOOL',
  SecondarySchool = 'SECONDARY_SCHOOL',
  College = 'COLLEGE',
}

export default MemberEducation;
